import { request as uploadBannerImage } from '../../../modules/banners/actions/upload-banner-image';
import { request as getAllBanners } from '../../../modules/banners/actions/get-all-banners';
import { error, finish } from '../../../modules/banners/actions/update-banner';
import api from '../../../api';

export function request(dispatch, { body }) {
    const {
        data,
        file
    } = body;

    if (file) {
        data.imageUrl = '';
        dispatch(uploadBannerImage({
            file,
            bannerId: data.id
        }));
    }

    api.put(`/banners/${data.id}`, data)
        .then(resp => {
            dispatch(finish(resp));
            if (!file) {
                dispatch(getAllBanners());
            }
        }).catch(err => {
            dispatch(error(err));
        });
}
